// extracted by mini-css-extract-plugin
export var text = "_70-0";